import { InventoryItemDTO } from "../../../shared/dtos";
import { DefaultSelectable } from "../../menu/interfaces";
import { IconPosition, TextAndIcon } from "../text-and-icon";

export class InventoryItem extends DefaultSelectable {
    private itemSprite: TextAndIcon;

    constructor(
        x: number,
        y: number,
        width: number,
        height: number,
        item: InventoryItemDTO,
        scene: Phaser.Scene
    ) {
        super(scene, x, y);

        let nameToDisplay = item.equipped_by
            ? "E " + item.item_definition.name
            : item.item_definition.name;
        if (item.quantity) {
            nameToDisplay += " x " + item.quantity;
        }

        this.itemSprite = new TextAndIcon(
            0,
            0,
            nameToDisplay,
            "items/" + item.item_definition.sprite_data.image_path,
            item.item_definition.sprite_data.frame_name,
            IconPosition.LEFT,
            scene
        );

        this.add(this.itemSprite);
    }
}
